module.exports = __webpack_public_path__ + "img/wedding_rings.f57c2c0.jpg";